import axios from '../../../helpers/AxiosConfig';
import { GetRolesResponse } from './roles.types';

export const getRoles = () => {
  return axios.get<GetRolesResponse>('role/getRoles');
};
